import { useState } from "react";
import Icon from "./Icon";
import StatsCard from "./StatsCard";
import { menuUrl } from "../../menu.js";

const copyText = async (text) => {
    try {
        await navigator.clipboard.writeText(text);
        return true;
    } catch (error) {
        const input = document.createElement("textarea");
        input.value = text;
        document.body.appendChild(input);
        input.select();
        const ok = document.execCommand("copy");
        input.remove();
        return ok;
    }
}

const PanelHome = ({ data, goTo, onAddProduct }) => {

    const { business, products, categories, canAddProduct } = data;
    const url = menuUrl(business.usuarioEmpresa);
    const [copied, setCopied] = useState(false);

    const steps = [
        { label: "Logo y datos del negocio", done: !!(business.logo && business.descripcionEmpresa && business.calle && business.telefono), tab: "negocio" },
        { label: "Horarios de atención", done: !!business.horario, tab: "negocio" },
        { label: "Crear una categoría", done: categories.length > 0, tab: "productos" },
        { label: "Cargar el primer producto", done: products.length > 0, tab: "productos" },
        { label: "Elegir los colores del menú", done: !!business.bodyColor, tab: "negocio" }
    ];
    const doneCount = steps.filter((s) => s.done).length;

    const handleCopy = async () => {
        if (await copyText(url)) {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        }
    }

  return (
    <div className="lp-panel-page">
        <div className="lp-panel-head">
            <div>
                <h1>¡Hola, {business.nombreEmpresa}!</h1>
                <p className="lp-panel-muted">Todo lo que cambies acá se ve al instante en tu menú.</p>
            </div>
            <div className="lp-panel-head-actions">
                <a className="lp-btn lp-btn-secondary" href={url} target="_blank" rel="noreferrer"><Icon name="external"></Icon> Ver mi menú</a>
                <button type="button" className="lp-btn lp-btn-primary" onClick={onAddProduct} disabled={!canAddProduct}><Icon name="plus"></Icon> Agregar producto</button>
            </div>
        </div>

        <div className="lp-panel-grid">
            <StatsCard business={business} products={products} onSeeAll={() => goTo("estadisticas")}></StatsCard>

            <section className="lp-panel-card lp-panel-stack">
                <h2>El link de tu menú</h2>
                <div className="lp-panel-url">{url.replace(/^https?:\/\//, "")}</div>
                <div className="lp-panel-actions">
                    <button type="button" className="lp-btn lp-btn-primary lp-panel-btn-sm" onClick={handleCopy}>
                        <Icon name={copied ? "check" : "copy"} size={18}></Icon> {copied ? "¡Copiado!" : "Copiar link"}
                    </button>
                    <a className="lp-btn lp-btn-secondary lp-panel-btn-sm" href={`https://wa.me/?text=${encodeURIComponent(`Mirá nuestro menú: ${url}`)}`} target="_blank" rel="noreferrer">
                        <Icon name="share" size={18}></Icon> Compartir por WhatsApp
                    </a>
                </div>
                <span className="lp-panel-sr" role="status">{copied ? "Link copiado" : ""}</span>
            </section>

            {doneCount < steps.length &&
                <section className="lp-panel-card lp-panel-stack">
                    <div className="lp-panel-card-head">
                        <h2>Completá tu menú</h2>
                        <span className="lp-panel-muted">{doneCount} de {steps.length}</span>
                    </div>
                    <div className="lp-panel-meter" aria-hidden="true"><span style={{ width: `${(doneCount / steps.length) * 100}%` }}></span></div>
                    <ul className="lp-panel-checklist">
                        {steps.map((s) => (
                            <li key={s.label} className={s.done ? "lp-panel-step-done" : ""}>
                                <span className="lp-panel-step-mark" aria-hidden="true">{s.done && <Icon name="check" size={14} strokeWidth={3}></Icon>}</span>
                                <span>{s.label}<span className="lp-panel-sr">{s.done ? " (listo)" : " (pendiente)"}</span></span>
                                {!s.done && <button type="button" className="lp-panel-step-go" onClick={() => goTo(s.tab)}>Hacerlo</button>}
                            </li>
                        ))}
                    </ul>
                </section>
            }

            <section className="lp-panel-card lp-panel-stack">
                <h2>Tu código QR</h2>
                <p className="lp-panel-muted">Descargalo en PNG o imprimí un cartel listo para la mesa o la vidriera.</p>
                <button type="button" className="lp-btn lp-btn-secondary lp-panel-btn-sm lp-panel-left" onClick={() => goTo("qr")}><Icon name="qr" size={18}></Icon> Ir al QR</button>
            </section>
        </div>
    </div>
  )
}

export default PanelHome
